import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitleAddStatus: {
		id: 'business-workflows.controllers.workflow-actions.create-status.error-flag-title-add-status',
		defaultMessage: 'Unable to create status',
		description: 'Title of error flag that is shown if create status is unsuccessful',
	},
});
